export const mergePoints = (clicks = {}, submissions = {}, attributedSubmissions = {}) => {
  const views = clicks.views || 0;
  const formSubmissions = submissions.formSubmissions || 0;
  const formSubmissionsRate = views && !submissions.formSubmissionsRate ? formSubmissions / views : submissions.formSubmissionsRate || 0;
  const attributedFormSubmissions = attributedSubmissions.attributedFormSubmissions || 0;
  const attributedFormSubmissionsRate = views && !attributedSubmissions.attributedFormSubmissionsRate ? attributedFormSubmissions / views : attributedSubmissions.attributedFormSubmissionsRate || 0;
  return {
    views,
    clicks: clicks.clicks || 0,
    clickRate: clicks.clickRate || 0,
    formSubmissions,
    formSubmissionsRate,
    attributedFormSubmissions,
    attributedFormSubmissionsRate
  };
};
export const mergeByInteractive = (clicks = [], submissions = [], attributedSubmissions = []) => {
  const formSubmissionsCountersById = submissions.reduce((acc, {
    interactiveId,
    counters
  }) => {
    acc[interactiveId] = counters;
    return acc;
  }, {});
  const attributedFormSubmissionsCountersById = attributedSubmissions.reduce((acc, {
    interactiveId,
    counters
  }) => {
    acc[interactiveId] = counters;
    return acc;
  }, {});
  return clicks.map(clicksCounters => {
    const interactiveId = clicksCounters.interactiveId;
    const formSubmissionsCounters = formSubmissionsCountersById[interactiveId];
    const attributedFormSubmissionsCounters = attributedFormSubmissionsCountersById[interactiveId];
    return Object.assign({}, clicksCounters, {
      counters: mergePoints(clicksCounters.counters, formSubmissionsCounters, attributedFormSubmissionsCounters)
    });
  });
};
const getPoint = point => point && {
  dateInt: point.dateInt,
  counters: {
    views: point.counters.views || 0,
    clicks: point.counters.clicks || 0,
    clickRate: point.counters.clickRate || 0,
    formSubmissions: point.counters.formSubmissions || 0,
    formSubmissionsRate: point.counters.formSubmissionsRate || 0,
    attributedFormSubmissions: point.counters.attributedFormSubmissions || 0,
    attributedFormSubmissionsRate: point.counters.attributedFormSubmissionsRate || 0
  }
};
export const mergePointSummaries = (clicks = [], submissions = [], attributedSubmissions = []) => {
  const merged = [];
  let clicksIdx = 0;
  let submissionsIdx = 0;
  let attributedSubmissionsIdx = 0;
  while (submissionsIdx < submissions.length || clicksIdx < clicks.length || attributedSubmissionsIdx < attributedSubmissions.length) {
    const clicksPoint = getPoint(clicks[clicksIdx]);
    const submissionsPoint = getPoint(submissions[submissionsIdx]);
    const attributedSubmissionsPoint = getPoint(attributedSubmissions[attributedSubmissionsIdx]);
    const minDateInt = Math.min((clicksPoint === null || clicksPoint === void 0 ? void 0 : clicksPoint.dateInt) || Infinity, (submissionsPoint === null || submissionsPoint === void 0 ? void 0 : submissionsPoint.dateInt) || Infinity, (attributedSubmissionsPoint === null || attributedSubmissionsPoint === void 0 ? void 0 : attributedSubmissionsPoint.dateInt) || Infinity);
    if (minDateInt === Infinity) {
      break;
    }
    const clicksMatchesDate = (clicksPoint === null || clicksPoint === void 0 ? void 0 : clicksPoint.dateInt) === minDateInt;
    const submissionsMatchesDate = (submissionsPoint === null || submissionsPoint === void 0 ? void 0 : submissionsPoint.dateInt) === minDateInt;
    const attributedSubmissionsMatchesDate = (attributedSubmissionsPoint === null || attributedSubmissionsPoint === void 0 ? void 0 : attributedSubmissionsPoint.dateInt) === minDateInt;
    merged.push({
      dateInt: minDateInt,
      counters: mergePoints(clicksPoint && clicksMatchesDate ? clicksPoint.counters : {}, submissionsPoint && submissionsMatchesDate ? submissionsPoint.counters : {}, attributedSubmissionsPoint && attributedSubmissionsMatchesDate ? attributedSubmissionsPoint.counters : {})
    });
    if (clicksMatchesDate) clicksIdx++;
    if (submissionsMatchesDate) submissionsIdx++;
    if (attributedSubmissionsMatchesDate) attributedSubmissionsIdx++;
  }
  return merged;
};